import React from 'react'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import { Grid } from '@material-ui/core'
import classes from './PageInfo.scss'

const PageInfo = ({ pageTranslateKey, translate }) => {
  return (
    <Grid container justify={'flex-start'}
      className={pageTranslateKey === 'individualAssignment' ? classes.warpIA : pageTranslateKey === 'corporateAssignment' ? classes.warpCA : null}>
      <Grid item className={classes.title}>
        {translate(pageTranslateKey)}
      </Grid>
    </Grid>
  )
}

export default withTranslate(PageInfo)
